import { useState } from "react";

/**
 * Reusable tag input.
 *  - Enter / comma commit the current input as a chip.
 *  - Backspace on empty input removes the last chip.
 *  - Values are trimmed and stripped of leading/trailing commas & whitespace.
 *  - Empty / duplicate chips are silently dropped.
 */
export default function TagInput({
  value,
  onChange,
  placeholder,
  testId,
  containerTestId,
}) {
  const [input, setInput] = useState("");

  const add = (raw) => {
    const cleaned = (raw || "").replace(/^[,\s]+|[,\s]+$/g, "").trim();
    if (!cleaned) return;
    if (value.includes(cleaned)) {
      setInput("");
      return;
    }
    onChange([...value, cleaned]);
    setInput("");
  };

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(input);
    } else if (e.key === "Backspace" && !input && value.length) {
      onChange(value.slice(0, -1));
    }
  };

  const remove = (tag) => onChange(value.filter((x) => x !== tag));

  return (
    <div
      className="flex flex-wrap items-center gap-1.5 rounded-lg border border-slate-300 bg-white px-2 py-1.5 shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20"
      data-testid={containerTestId}
    >
      {value.map((s) => (
        <span
          key={s}
          data-testid={testId ? `${testId}-tag-${s}` : undefined}
          className="inline-flex items-center gap-1 rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700"
        >
          {s}
          <button
            type="button"
            onClick={() => remove(s)}
            className="text-indigo-500 hover:text-indigo-700"
            aria-label={`remove ${s}`}
          >
            ×
          </button>
        </span>
      ))}
      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={onKey}
        onBlur={() => add(input)}
        placeholder={placeholder}
        className="min-w-[10ch] flex-1 border-0 bg-transparent px-1 py-0.5 text-sm text-slate-900 focus:outline-none focus:ring-0"
        data-testid={testId}
      />
    </div>
  );
}
